// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2sWt6","topBottomGutter":"Layout_topBottomGutter__20kXO"};